import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import EditCatalogTypes from './EditCatalogTypes'
import ListCatalogTypes from './ListCatalogTypes'
import NewCatalogTypes from './NewCatalogTypes'

const AdminCatalogTypesRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListCatalogTypes /></PrivateRoute7>} />
        <Route path="edit-catalog-type" element={<PrivateRoute7><EditCatalogTypes /></PrivateRoute7>} />
        <Route path="new-catalog-type" element={<PrivateRoute7><NewCatalogTypes /></PrivateRoute7>} />
    </Routes>
  )
}

export default AdminCatalogTypesRoutes